<template>
  <div
    :class="`${element.compData.type}-theme-${element.compData.styleId}`"
    :style="{...getStyles(element.compData.styles),
    width: element.width + 'px',
    height: element.height + 'px'}"
  >
    <div :class="['input', element.compData.inputBorder == 'true' ? 'inputBorder' : '']">
      <Input search v-model="element.compData.value" :placeholder="element.compData.placeHolder" @on-search="handleClick"></Input>
    </div>
  </div>
</template>

<script>
// iview
import {
  Input
} from "view-design";
import {debounce} from 'lodash'
export default {
  name: "compInput",
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      debounceF: null,
      loading: true
    };
  },
  watch: {
    'element.compData.value': {
      handler(val) {
        this.debounceF()
      },
      deep: true
    }
  },
  methods: {
    handleClick() {
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onclick',
        eventData: {
          value: {
            value: this.element.compData.value,
          },
          data: this.plugin,
          event: null
        }
      })
    },
    getStyles (styles) {
      if (!styles) return
      const res = {}
      Object.keys(styles).forEach((item) => {
        res[`--${item}`] = (typeof styles[item] === 'number') ? styles[item] + 'px' : styles[item]
      })
      return res
    }
  },
  mounted () {
    let that = this
    this.debounceF = debounce(function() {
      that.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: that.element.id,
        dataKey: 'valueChange',
        eventData: {
          value: {
            value: that.element.compData.value,
          },
          data: that.plugin,
          event: null
        }
      })
    }, 500)
    this.$nextTick(() => {
      this.loading = false
      this.$nextTick(() => {
      this.$blueMap.trigger({
        nodeType: 'plugin',
        pluginId: this.element.id,
        dataKey: 'onmounted',
        eventData: {
          value: null,
          data: this.plugin,
          event: null
          }
        })
      })
    })
  },
  components: {
    Input
  }
};
</script>

<style lang='less' scoped>
  .input {
    width: 100%;
    height:100%;
  }
  /deep/.ivu-input {
    height: var(--inputHeight);
    font-size: var(--fontSize);
    background-color: var(--inputBgColor);
    color: var(--fontColor);
    font-family: var(--fontFamily) !important;
    border-radius: var(--radiusSize);
    padding: 0 var(--paddingRight);
  }
  /deep/.ivu-input-icon{
      font-size: var(--fontSize);
      height: var(--inputHeight);
      line-height: var(--inputHeight);
      color: var(--btnColor);
  }
  .inputBorder {
    /deep/.ivu-input {
      border-color: var(--borderColor);
      border-width: var(--borderWidth);
    }
  }

</style>
